export const errorPage = {
    errorCode: "404",
    errorDescription: "Hier ist ein Fehler aufgetreten.",
    backToHomeScreen: "Zurück zur Startseite",
    errorExplanation1: "Diese Seite wurde verschoben oder ist nicht mehr verfügbar.",
    errorExplanation2: "Der Server konnte Ihre Anfrage leider nicht verarbeiten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut"

}